export class Document {
	name = null;
	type = "";
	file = {};
}
